export const PRODUCTION_API_BASE = 'https://api.zoediagnostics.ai';
export const LOCAL_API_BASE = '';

declare global {
  interface Window {
    __ZOE_API_URL?: string;
  }
}

function normalizeApiBase(value: string): string {
  return value.trim().replace(/\/+$/, '');
}

function nonEmpty(value: string | undefined): string | undefined {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
}

function isLoopbackHost(hostname: string): boolean {
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '[::1]' ||
    hostname === '::1'
  );
}

function isProxyableDevApiBase(value: string): boolean {
  if (typeof window !== 'undefined' && value === window.location.origin) return true;
  try {
    return isLoopbackHost(new URL(value).hostname);
  } catch {
    return false;
  }
}

export function getApiBase(): string {
  if (typeof window !== 'undefined') {
    const runtimeOverride = nonEmpty(window.__ZOE_API_URL);
    if (runtimeOverride) return normalizeApiBase(runtimeOverride);
  }

  const viteOverride = nonEmpty(import.meta.env.VITE_PUBLIC_API_URL) ?? nonEmpty(import.meta.env.VITE_API_URL);
  if (viteOverride) {
    const normalized = normalizeApiBase(viteOverride);
    if (import.meta.env.DEV && isProxyableDevApiBase(normalized)) return LOCAL_API_BASE;
    return normalized;
  }

  return import.meta.env.DEV ? LOCAL_API_BASE : PRODUCTION_API_BASE;
}

export const API_BASE = getApiBase();
